import { ReactElement } from 'react';
import { ErrorOption, FieldError, FieldErrors, UseFormRegister } from 'react-hook-form';
import { baseClass, RegisterFormData } from './CreateAccount';
import { FormFeedback, FormGroup } from '../../components';

export interface InputProps extends Omit<InputGroupProps, 'setError'> {
  name: string;
  id: string;
}

export interface InputGroupProps {
  register: UseFormRegister<RegisterFormData>;
  errors: FieldErrors<RegisterFormData>;
  setError: (name: string, error: ErrorOption) => void;
}

export const InputField = ({ register, errors, id, name }: InputProps): ReactElement => (
  <FormGroup className={`${baseClass}__form-group`}>
    <label htmlFor={id}>
      <span className={`${baseClass}__label`}>{name}</span>
      <input
        {...register(id)}
        className={`${baseClass}__input vol-input`}
        name={id}
        maxLength={30}
        data-testid={`${id}Input`}
      />
    </label>

    <FormFeedback data-testid="usernameFeedback" className={`${baseClass}__feedback`}>
      {errors?.[id as keyof FieldError]?.message}
    </FormFeedback>
  </FormGroup>
);

export default InputField;
